import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const TermsPage = () => {
  return (
    <>
      <Helmet>
        <title>Terms of Service — Searchefy</title>
        <meta name="description" content="Searchefy Terms of Service. Read the terms and conditions for using our platform." />
        <link rel="canonical" href="https://searchefy.com/terms" />
      </Helmet>

      <div data-testid="terms-page" className="min-h-screen bg-[#F9FAFB]">
        <Navbar />
        <main className="pt-24 pb-24">
          <div className="max-w-3xl mx-auto px-6 md:px-12">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              <h1 className="font-display text-4xl font-bold text-gray-900 mb-8">Terms of Service</h1>
              
              <div className="prose prose-gray max-w-none">
                <p className="text-gray-600 mb-6">Last updated: December 2025</p>
                
                <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">1. Acceptance of Terms</h2>
                <p className="text-gray-600 mb-6">
                  By accessing or using Searchefy, you agree to be bound by these Terms of Service. If you do not agree, please do not use our service.
                </p>

                <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">2. Service Description</h2>
                <p className="text-gray-600 mb-6">
                  Searchefy provides a backlink directory and project tracking tool. We offer lifetime access for a one-time payment of $9 USD.
                </p>

                <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">3. Payment and Refunds</h2>
                <p className="text-gray-600 mb-6">
                  All sales are final. Due to the immediate access to digital content and the low price point, we do not offer refunds. If you experience technical issues, contact us and we'll work to resolve them.
                </p>

                <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">4. User Responsibilities</h2>
                <p className="text-gray-600 mb-4">You agree to:</p>
                <ul className="list-disc pl-6 text-gray-600 mb-6">
                  <li>Provide accurate account information</li>
                  <li>Maintain the security of your account</li>
                  <li>Use the service in compliance with applicable laws</li>
                  <li>Not share or resell your account access</li>
                </ul>

                <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">5. Intellectual Property</h2>
                <p className="text-gray-600 mb-6">
                  All content, features, and functionality of Searchefy are owned by us and protected by intellectual property laws. The backlink directory data is for your personal or business use only and may not be redistributed.
                </p>

                <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">6. Limitation of Liability</h2>
                <p className="text-gray-600 mb-6">
                  Searchefy is provided "as is" without warranties of any kind. We are not responsible for the results of your link-building campaigns or changes in third-party website policies.
                </p>

                <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">7. Changes to Terms</h2>
                <p className="text-gray-600 mb-6">
                  We may update these terms from time to time. Continued use of the service after changes constitutes acceptance of the new terms.
                </p>

                <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">8. Contact</h2>
                <p className="text-gray-600">
                  Questions about these Terms? Contact us at{' '}
                  <a href="mailto:thepratishjain@gmail.com" className="text-blue-600 hover:underline">
                    thepratishjain@gmail.com
                  </a>
                </p>
              </div>
            </motion.div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default TermsPage;
